import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ isAuthenticated, hasPermission, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }
  if (!hasPermission) {
    return <Navigate to="/unauthorized" replace />; // Redirect to an unauthorized page or a specific route
  }
  return children;
};

export default ProtectedRoute;
